import { API_BASE } from '../config/api';

export const spreadsheetApi = {
  async upload(file, companyIdSlug) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('company_id_slug', companyIdSlug);
    
    const response = await fetch(`${API_BASE}/api/spreadsheets/upload`, {
      method: 'POST',
      body: formData,
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Upload failed');
    }
    
    return response.json();
  },
  
  async query(queryText, companyIdSlug, sessionId, filename = null) {
    const payload = {
      query: queryText,
      company_id_slug: companyIdSlug,
      session_id: sessionId,
    };
    
    // Add filename filter if provided
    if (filename) {
      payload.filename = filename;
    }
    
    const response = await fetch(`${API_BASE}/api/spreadsheets/query`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Query failed');
    }
    
    return response.json();
  },
  
  async getStatus(companyIdSlug) {
    const url = `${API_BASE}/api/spreadsheets/status/${companyIdSlug}`;
    const response = await fetch(url);

    if (!response.ok) {
      const error = await response.json();
      console.error('[SpreadsheetAPI] Error response:', error);
      throw new Error(error.error || 'Status check failed');
    }

    const data = await response.json();
    return data;
  },
  
  async delete(spreadsheetId) {
    const response = await fetch(`${API_BASE}/api/spreadsheets/delete/${spreadsheetId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });
    
    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Delete failed' }));
      throw new Error(error.error || 'Delete failed');
    }
    
    return response.json();
  },
};

